import React from 'react';
import { Calendar } from 'lucide-react';
import { trackBookNowClick } from '../utils/analytics';
import './FloatingBookButton.css';

const FloatingBookButton = () => {
  const handleBookNow = () => {
    trackBookNowClick();
    window.location.href = '/contact';
  };

  return (
    <button
      data-testid="floating-book-now-btn"
      onClick={handleBookNow}
      className="floating-book-button"
      aria-label="Book Now"
    >
      <Calendar className="w-5 h-5" />
      <span>Book Now</span>
    </button>
  );
};

export default FloatingBookButton;
